var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAzure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 142 109.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 1",
    d: "m83.15 7.64 58.85 102H36l64-11.27c-.65-.87-1-1.37-1.38-1.83Q82.5 77.35 66.42 58.2c-.71-.84-1.24-1.55-.76-2.85Q74.16 32.17 82.54 9c.12-.35.3-.67.61-1.32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 3",
    d: "M0 97.49c1-1.74 1.74-3.1 2.52-4.46q16.19-28.36 32.41-56.71a11.21 11.21 0 0 1 2.41-2.86Q56.44 17.17 75.59 1c.28-.24.59-.44 1.3-1-.41 1-.61 1.65-.88 2.23Q54.5 48.86 33 95.51a2.91 2.91 0 0 1-3.1 2c-9.24-.09-18.49 0-27.73 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzure);
export default __webpack_public_path__ + "static/media/azure.e9cf8c6b925da622b5b343e5e1fccbf5.svg";
export { ForwardRef as ReactComponent };